import { Injectable, ComponentRef, Provider } from '@angular/core';
import { ICookieInformationDialogService, ICookieInformationDialogServiceToken } from 'shared/services/ui/dialogs/cookie-information/cookie-information-dialog-service.abstract';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { CookieNoticeDialogMHComponent } from '../../components/shared/cookie/notice-dialog/cookie-notice-dialog.component';

@Injectable({
  providedIn: 'root',
}) export class CookieInformationDialogService implements ICookieInformationDialogService {

  cookieInformationDialogShow(
    callbackAgree: () => void
  ) {
    DialogBaseService.dialogGenericShow(
      CookieNoticeDialogMHComponent,
      (component: ComponentRef<CookieNoticeDialogMHComponent>) => {
        component.instance.modalAgree.subscribe(
          () => {
            callbackAgree();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.modalCancel.subscribe(
          () => {
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CookieInformationDialogServiceProvider: Provider[] = [
  { provide: ICookieInformationDialogServiceToken, useExisting: CookieInformationDialogService }
];
